<template>
	<v-app-bar app clipped-right absolute class="pr-2 pl-1 mt-3 mx-3 head_bg" elevation="0" rounded :class="$vuetify.theme.dark ? '' : 'white'">
		<v-toolbar-title class="font-weight-medium vtk-cursor-pointer" @click="toHome">{{ $vtk.env.VUE_APP_HEAD }}</v-toolbar-title>
		<v-spacer />
		<v-btn v-show="user && user.uniCode && user.uniCode == '91330108MA2H3MND51'" to="/uams-dept-roles-page" class="ml-4 px-0" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
			<v-icon color="blue">mdi-cog-outline</v-icon>
		</v-btn>
		<v-btn class="ml-4 px-0" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
			<v-icon color="blue">mdi-bell-outline</v-icon>
		</v-btn>
		<v-btn class="ml-4 px-0 g-d-sm-none" @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
			<v-icon color="blue">mdi-theme-light-dark</v-icon>
		</v-btn>
		<v-btn class="ml-4 px-0 g-d-sm-none" @click="exit" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
			<v-icon color="blue">mdi-power</v-icon>
		</v-btn>
	</v-app-bar>
</template>

<script>
import Storage from "@/commons/storage";
import Message from "@/components/message";
import Request from "@/commons/request";
export default {
	data() {
		return {
			user: {},
		};
	},
	mounted() {
		this.user = Storage.get("_wit_acis_users");
	},
	methods: {
		exit() {
			Message.confirm({ title: "确认退出", text: "确认清除数据并退出吗？" }, (res) => {
				if (res) {
					Request.postForm("/unia/admin/logix").then((res) => {
						if (res.meta.success) {
							Storage.clear(); //清除所有缓存
							window.document.location.href = this.$vtk.env.VUE_APP_LOGIX;
						}
					});
				}
			});
		},
		toHome() {
			!location.href.includes("/home") && this.$router.push({ path: "/home" });
		},
	},
};
</script>
<style lang="scss" scoped>
.head_bg {
	background-image: url(../../assets/img/head_bg.png);
	background-size: cover;
}
</style>
